import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { ExpenseDefaultsState, ExpenseDefaultsStore } from './expense-defaults.store';

@Injectable({ providedIn: 'root' })
export class ExpenseDefaultsQuery extends Query<ExpenseDefaultsState> {
  constructor(protected store: ExpenseDefaultsStore) {
    super(store);
  }
}
